<ng-container *ngIf="dataManager$ | async as data">
  <datalean-tree-browser [allowSearch]="true" [config]="config" [nodes]="data" (selected)="selectionChanged($event)">
  </datalean-tree-browser>
</ng-container>

<div class="buttons-container">
  <button (click)="close()">{{ 'ADD' | translate }}</button>
</div>
